import React, { useState } from 'react';
import styled from 'styled-components';

import Card from '@styled/Containers/Card';

import AlertLookup from './Main/AlertLookup';
import DecisionSummary from './Main/DecisionSummary';

const CardOverlay = styled(Card)`
  z-index: 999;
`;

const CardSection = styled(Card)`
  margin-top: 40px;
  margin-bottom: 40px;
`;

const Main = ({ keys }) => {
  const [search, setSearch] = useState('');
  const [timestamp, setTimestamp] = useState('');

  const handleSubmit = data => {
    setTimestamp(new Date().toISOString());
    setSearch(data);
  };

  return (
    <div>
      <CardOverlay>
        <AlertLookup query={search} setQuery={setSearch} setSearch={handleSubmit} />
      </CardOverlay>

      {search && search.length > 0 && (
        <CardSection>
          <DecisionSummary id={search} timestamp={timestamp} />
        </CardSection>
      )}
    </div>
  );
};
export default Main;
